module.exports = __webpack_public_path__ + "static/directory_3@3x-728a952b232e5d1186db276d76588154.png";